import * as yup from 'yup';

export const schemaMap = {
  text: yup.string().required('common:formErrors.required'),
  textarea: yup.string().required('common:formErrors.required'),
  integer: yup
    .number()
    .nullable()
    .integer('Must be an integer')
    .typeError('Must be a number'),
  boolean: yup.boolean().default(true).required('common:formErrors.required'),
  select: yup.string().required('common:formErrors.required'),
  tabs: yup.string().required('common:formErrors.required'),
  money: yup
    .number()
    .nullable()
    .min(0)
    .max(9999999)
    .typeError('Must be a number'),
  date: yup
    .date()
    .nullable()
    .required('common:formErrors.required')
    .transform(value => {
      if (typeof value === 'string') {
        return new Date(value);
      }

      return value;
    }),
  company: yup.mixed().required().nullable(),
  dynamicList: yup.string().required(),
};
